import React from "react";
import { cn } from "../../utils/cn";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";
import {
  SmartPopover,
  SmartPopoverMenu,
  SmartPopoverTrigger,
} from "../../popover";

interface Props {
  variant?: "primary" | "secondary";
  label: string | JSX.Element;
  className?: string;
  children?: React.ReactNode;
}

export const DropdownButton = ({ className, label, children }: Props) => (
  <SmartPopover>
    <SmartPopoverTrigger
      className={cn(
        "rounded-xl p-2 text-sm font-medium active:scale-90 transition-all duration-100 bg-gray-1 hover:bg-gray-3",
        className,
      )}
    >
      <div className="flex flex-row justify-between items-center gap-1">
        {label}
        <FontAwesomeIcon icon={faArrowDown} className="h-3 w-3 text-gray-800" />
      </div>
    </SmartPopoverTrigger>
    <SmartPopoverMenu>{children}</SmartPopoverMenu>
  </SmartPopover>
);
